
const Animations = {

	observer: null,

	init: function () {
		this.observer = new IntersectionObserver(this.observerCallback.bind(this), {threshold: 0.25});
		const elements = document.querySelectorAll('.slide-up');
		for (let i = 0; i < elements.length; i++) {
			this.observer.observe(elements[i]);
		}
	},

	observerCallback: function (entries) {
		for (let i = 0; i < entries.length; i++) {
			if (entries[i].isIntersecting) {
				entries[i].target.classList.add('animate');
				this.observer.unobserve(entries[i].target);
			}
		}
	},

}

export default Animations;
